import { useQuery } from '@tanstack/react-query';
import { HTTPError } from 'ky';

import { fetchROC } from '@/adapters/fetchExaCare';

interface ReferralDocument {
  document_id: string;
  referral_id: string;
  document_type: string;
  file_name: string;
  s3_key: string;
  content_type: string;
  file_size_bytes: number;
  page_count: number;
  uploaded_by_user_id: string;
  created_at: string;
}

interface DocumentsResponse {
  items: ReferralDocument[];
  cursor: string | null;
}

export type { ReferralDocument };

export const FIND_ALL_REFERRAL_DOCUMENTS_QUERY_KEY = 'findAllReferralDocuments';

interface UseDocumentsQueryOptions {
  enabled?: boolean;
}

export function useDocumentsQuery(
  referralId: string,
  options: UseDocumentsQueryOptions = {}
) {
  return useQuery({
    queryKey: [FIND_ALL_REFERRAL_DOCUMENTS_QUERY_KEY, referralId],
    queryFn: async () => {
      const response = await fetchROC.get<DocumentsResponse>(
        `/referrals/${referralId}/documents`,
        { searchParams: { limit: 100 } }
      );
      return response.items;
    },
    staleTime: 30 * 1000,
    enabled: !!referralId && (options.enabled ?? true),
    retryOnMount: false,
    retry: (failureCount, error) => {
      const status = error instanceof HTTPError ? error.response.status : null;
      if (status !== null && status < 500) {
        return false;
      }
      return failureCount < 3;
    }
  });
}
